import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1836e866&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1836e866')) {
      api.createRecord('1836e866', component.options)
    } else {
      api.reload('1836e866', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1836e866&", function () {
      api.rerender('1836e866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/index.vue"
export default component.exports